export const SUCCESS = "success";
export const Fail = "fail";
export const Error = "error";